import React, { PureComponent } from 'react'
import classnames from 'classnames'

import { ChatIcon } from './Icons'

import './Language.css'

export default class Languages extends PureComponent {
  touched = code => e => {
    const { onChanged } = this.props
    onChanged(code)
  }

  render() {
    const { language: { name, code }, selected } = this.props
    const languageClasses = classnames('cm-language', {
      'cm-language__selected': selected
    })
    return (
      <button
        className={languageClasses}
        id={`btn-language-${code}`}
        onClick={this.touched(code)}
      >
        <ChatIcon className="cm-language--marker" />
        <div className="cm-language--infos">
          <div className="cm-language--name">{name}</div>
        </div>
      </button>
    )
  }
}



// WEBPACK FOOTER //
// ./src/Language.js